<template>
  <div>
    <el-form ref="form" :inline="true" class="query-form" size="mini">
      <el-form-item class="query-form-item">
      </el-form-item>
      <el-form-item>
        <el-button type="success" size="mini" @click="openAddDialog">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="list"
      :height="tableHeight"
      size="mini"
      border
      style="width: 100%"
    >
      <el-table-column label="ID" prop="id" width="80" align="center" />

      <!-- 动态国家列：有几个国家就展示几个 -->
      <el-table-column
        v-for="country in countryColumns"
        :key="country.us"
        :label="country.title"
        align="center"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="openEditDialog(scope.row, country.us)"
          >
            {{ scope.row[country.us] || '-' }}
          </el-link>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="query.limit"
      :page-sizes="[10, 20, 50]"
      :total="query.total"
      background
      :current-page="query.page"
      style="margin-top: 10px; display: flex; justify-content: end"
      layout="total, sizes, prev, pager, next"
    />

    <!-- 编辑弹窗 -->
    <el-dialog
      title="修改类目映射"
      :visible.sync="editDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="国家">
          <span>{{ getCountryTitle(editForm.field) }}</span>
        </el-form-item>
        <el-form-item label="当前类目ID">
          <span>{{ editForm.originValue || '-' }}</span>
        </el-form-item>
        <el-form-item label="新的类目">
          <el-select
            v-model="editForm.value"
            filterable
            clearable
            placeholder="请选择类目"
            style="width: 300px"
          >
            <el-option
              v-for="item in currentCountryCategoryList"
              :key="item.id"
              :label="item.name || item.title || item.string"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdate">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增类目映射"
      :visible.sync="addDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item
          v-for="country in countryColumns"
          :key="country.us"
          :label="country.title"
        >
          <el-select
            v-model="addForm[country.us]"
            filterable
            clearable
            placeholder="请选择类目"
            style="width: 300px"
          >
            <el-option
              v-for="item in getCategoryListByCountry(country.us)"
              :key="item.id"
              :label="item.name || item.title || item.string"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'

export default {
  name: 'CategoryMapping',
  data() {
    return {
      loading: false,
      tableHeight: null,
      list: [],
      query: {
        id: '',
        page: 1,
        limit: 10,
        total: 0
      },
      categoryList: [],
      editDialogVisible: false,
      addDialogVisible: false,
      editForm: {
        id: null,
        field: '',
        value: '',
        originValue: ''
      },
      addForm: {}
    }
  },
  computed: {
    // 列表里真实出现过的国家（根据 us_arr 过滤）
    countryColumns() {
      const usedKeys = new Set()
      this.list.forEach(row => {
        this.$common.us_arr.forEach(item => {
          if (row[item.us] !== undefined) {
            usedKeys.add(item.us)
          }
        })
      })
      return this.$common.us_arr.filter(item => usedKeys.has(item.us))
    },
    currentCountryCategoryList() {
      if (!this.editForm.field) return []
      return this.getCategoryListByCountry(this.editForm.field)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.tableHeight =
        window.innerHeight - 140 - (this.$refs.form ? this.$refs.form.$el.offsetHeight : 0)
      window.addEventListener('resize', this.handleResize)
      this.fetchCategoryOptions()
      this.getList()
    },
    handleResize() {
      if (this.$refs.form) {
        this.tableHeight =
          window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
      }
    },
    fetchCategoryOptions() {
      api.manager_index_get_category_message().then(res => {
        if (res.code === 0) {
          this.categoryList = res.data || []
        } else {
          this.$message.error(res.message || '获取类目选项失败')
        }
      })
    },
    getCategoryListByCountry(countryKey) {
      // 后端类目数据里，一般会有 state / country 字段标识国家
      return (this.categoryList || []).filter(item => {
        return (
          item.state === countryKey ||
          item.country === countryKey ||
          item.us === countryKey
        )
      })
    },
    getCountryTitle(countryKey) {
      const item = this.$common.us_arr.find(v => v.us === countryKey)
      return item ? item.title : countryKey
    },
    getList() {
      this.loading = true
      const params = {
        page: this.query.page,
        limit: this.query.limit
      }
      if (this.query.id) {
        params.id = this.query.id
      }
      api.category_category_mapping_index(params)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            const data = res.data || {}
            this.list = data.list || []
            this.query.total = data.total || 0
          } else {
            this.$message.error(res.message || '获取列表失败')
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 查询
    onSubmit() {
      this.query.page = 1
      this.getList()
    },
    // 重置
    onReset() {
      this.query = {
        id: '',
        page: 1,
        limit: 10,
        total: 0
      }
      this.getList()
    },
    // 分页
    handleCurrentChange(val) {
      this.query.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    openEditDialog(row, field) {
      this.editForm = {
        id: row.id,
        field,
        value: row[field] || '',
        originValue: row[field] || ''
      }
      if (!this.categoryList.length) {
        this.fetchCategoryOptions()
      }
      this.editDialogVisible = true
    },
    handleUpdate() {
      if (!this.editForm.value) {
        this.$message.warning('请选择新的类目')
        return
      }
      const payload = {
        id: this.editForm.id,
        field: this.editForm.field,
        value: this.editForm.value
      }
      api.category_category_mapping_update(payload).then(res => {
        if (res.code === 0 || res.success) {
          this.$message.success(res.data || '更新成功')
          this.editDialogVisible = false
          this.getList()
        } else {
          this.$message.error(res.data || '更新失败')
        }
      })
    },
    openAddDialog() {
      // 根据当前列表出现过的国家初始化表单
      const form = {}
      this.countryColumns.forEach(item => {
        form[item.us] = ''
      })
      this.addForm = form
      if (!this.categoryList.length) {
        this.fetchCategoryOptions()
      }
      this.addDialogVisible = true
    },
    handleAdd() {
      const payload = {}
      Object.keys(this.addForm).forEach(key => {
        if (this.addForm[key]) {
          payload[key] = this.addForm[key]
        }
      })
      if (!Object.keys(payload).length) {
        this.$message.warning('请至少选择一个国家的类目')
        return
      }
      api.category_category_mapping_add(payload).then(res => {
        if (res.code === 0 || res.success) {
          this.$message.success(res.message || '添加成功')
          this.addDialogVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '添加失败')
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该映射记录吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          return api.category_category_mapping_deleted({ id: row.id })
        })
        .then(res => {
          if (!res) return
          if (res.code === 0 || res.success) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {})
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
  color: red;
  font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mini_div .el-button--mini {
  padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
  padding: 0 0 !important;
}
</style>
